import { PendenciaMensagem, TipoMensagemEnum } from '@/types/_'
import { groupCollectionByField, maskHour } from '@/utils/common'
import { Component, Emit, Prop, Vue } from 'vue-property-decorator'

@Component
export default class ComponentModalAdministrativePendency extends Vue {
  private messages: Partial<PendenciaMensagem>[] = []
  currentMessage: string = ''

  @Prop({ default: false }) messagesRequired = false

  @Prop({ default: false }) open = false
  @Prop() patientName = ''
  @Prop() doctorName = ''
  @Prop({ default: 'Abrir pendência' }) acceptText: string
  @Prop({ default: 'red darken-1' }) acceptColor: string

  addMessage() {
    const message: Partial<PendenciaMensagem> = {
      mensagemHospital: true,
      dataEnvio: new Date().toISOString(),
      tipoMensagem: TipoMensagemEnum.Texto,
      texto: this.currentMessage,
    }

    this.messages.push(message)

    this.currentMessage = ''
  }

  @Emit()
  accept() {
    const { messages } = this
    this.messages = []
    return messages.map<string>(elem => elem.texto!)
  }

  @Emit()
  cancel() {
    this.open = false
    this.messages = []
  }

  formatHour(value: string) {
    return maskHour(value)
  }

  get groupedMessages() {
    return groupCollectionByField(this.messages)
  }

  get canAccept() {
    if (this.messagesRequired) {
      return this.messages.length > 0
    }

    return true
  }
}
